<template>
  <div>
    <div class="bannerbg">
      <img
        :src="src"
        class="bannerbg_pic"
      />
      <div class="bannerbg_desc">
        <div class="bannerbg_desc_title">{{title}}</div>
        <div class="bannerbg_desc_entitle">{{subtitle}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerBg",
  props:{
      title:"",//标题
      subtitle:"",//英文标题
      src:""    //背景图 link
  }
};
</script>
<style lang="scss" scoped>
.bannerbg {
  position: relative;
  height: 339px;
  overflow: hidden;
  .bannerbg_pic {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
    height: 339px;
    object-fit: cover;
    width: 100%;
    display: block;
  }
  .bannerbg_desc {
    position: relative;
    z-index: 1;
    width: 1200px;
    margin: 0 auto;
    margin-top: 76px;
    padding-left: 40px;
    box-sizing: border-box;
    .bannerbg_desc_title {
      height: 70px;
      font-size: 50px;
      font-weight: 600;
      color: #ffffff;
      line-height: 70px;
    }
    .bannerbg_desc_entitle {
      height: 42px;
      font-size: 22px;
      // font-weight: 600;
      color: #ffffff;
      line-height: 42px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// BannerBg.vue?1db92d5e